<template>
  <!-- 根元素添加动态主题类，根据current切换颜色 -->
  <div class="bodyMain" :class="themeClass">
    <div class="tabs fcb">
      <div
        class="tab fccC f1"
        @click="change(index)"
        v-for="(item, index) in tabs"
        :key="index"
        :class="{ choose: current == index }"
      >
        <img
          class="icon"
          :src="current == index ? item.icon : item.iconN"
          alt=""
        />
        <div class="title">{{ item.label }}</div>
      </div>
    </div>
    <div class="main">
      <!-- 支付宝 / 微信 通用提示 -->
      <div class="tip fcc" v-if="current !== 2">
        <img src="./assets/zfb/wait.png" alt="" />
        <div class="">预计此项花费 1~2 分钟</div>
      </div>

      <!-- 银行账单：未选择银行时顶部标题栏 -->
      <div class="bank-header" v-if="current === 2">
        <div class="bank-header-title">年度账单</div>
        <div class="bank-header-picker" @click="openBankDrawer">
          <span>{{ selectedBank ? selectedBank.name : "请选择常用银行" }}</span>
        </div>
      </div>

      <!-- 银行账单：未选择银行空状态 -->
      <div class="bank-empty" v-if="current === 2 && !selectedBank">
        <img class="bank-empty-bg" :src="tdPng" alt="" />
        <div class="bank-empty-tip">
          <div class="bank-empty-tip1">您还未选择银行~</div>
          <div class="bank-empty-tip2">点击上方选择您需要下载账单的银行</div>
          <div class="bank-empty-tip3">
            <img :src="ggtPng" alt="" />
            若已下载账单可点击下方按钮上传账单文件哦~
          </div>
        </div>
        <!-- <div class="up-bill" @click="handleUpload">上传账单</div> -->
      </div>

      <!-- 银行账单：已选择银行指南 -->
      <div class="bank-guide" v-if="current === 2 && selectedBank">
        <div class="content">
          <div
            class="once"
            v-for="(item, index) in currentBankGuide"
            :key="index"
          >
            <div class="name">
              <i class="el-icon-success"></i>{{ item.name }}
            </div>
            <div
              class="mainC"
              v-for="(stem, sndex) in item.msgList || []"
              :key="sndex"
            >
              <div class="msg" v-if="stem.msg">{{ stem.msg }}</div>
              <div class="imgs" v-if="stem.imgs">
                <div
                  :class="{ imgOnce: !gtem.t }"
                  v-for="(gtem, gndex) in stem.imgs"
                  :key="gndex"
                >
                  <div class="">{{ gtem.t }}</div>
                  <el-image
                    class="el-image"
                    v-if="!gtem.t"
                    :src="gtem.m || gtem"
                    style="margin-right: 4px"
                    :style="{ width: gtem.sw }"
                    alt=""
                    :preview-src-list="bankSrcList"
                  />
                </div>
              </div>
              <div
                class="msgs"
                :class="{ blueBox: stem.blueBox }"
                v-if="stem.msgs"
              >
                <span alt="" v-for="(mtem, mndex) in stem.msgs" :key="mndex">
                  <span v-if="mtem.t" class="t">{{ mtem.t }}</span>
                  <span v-if="mtem.r1" class="r1">{{ mtem.r1 }}</span>
                  <span v-if="mtem.r2" class="r2">{{ mtem.r2 }}</span>
                  <span v-if="mtem.b1" class="b1">{{ mtem.b1 }}</span>
                </span>
              </div>
              <div class="times" v-if="stem.times">
                <div class="title">{{ stem.times.name }}</div>
                <div class="begin">
                  <span class="t">起始时间</span>{{ stem.times.begin }}
                </div>
                <div class="end">
                  <span class="t">结束时间</span>{{ stem.times.end }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 支付宝 / 微信 内容 -->
      <div class="content" v-if="current !== 2">
        <div class="once" v-for="(item, index) in useContent" :key="index">
          <div class="name"><i class="el-icon-success"></i>{{ item.name }}</div>
          <div
            class="mainC"
            v-for="(stem, sndex) in item.msgList || []"
            :key="sndex"
          >
            <div class="msg" v-if="stem.msg">{{ stem.msg }}</div>
            <div class="imgs" v-if="stem.imgs">
              <div
                :class="{ imgOnce: !gtem.t }"
                v-for="(gtem, gndex) in stem.imgs"
                :key="gndex"
              >
                <div class="">{{ gtem.t }}</div>
                <el-image
                  class="el-image"
                  v-if="!gtem.t"
                  :src="gtem.m || gtem"
                  style="margin-right: 4px"
                  :style="{ width: gtem.sw }"
                  alt=""
                  :preview-src-list="srcList"
                />
              </div>
            </div>
            <div
              class="msgs"
              :class="{ blueBox: stem.blueBox }"
              v-if="stem.msgs"
            >
              <span alt="" v-for="(mtem, mndex) in stem.msgs" :key="mndex">
                <span v-if="mtem.t" class="t">{{ mtem.t }}</span>
                <span v-if="mtem.r1" class="r1">{{ mtem.r1 }}</span>
                <span v-if="mtem.r2" class="r2">{{ mtem.r2 }}</span>
                <span v-if="mtem.b1" class="b1">{{ mtem.b1 }}</span>
              </span>
            </div>
            <div class="times" v-if="stem.times">
              <div class="title">{{ stem.times.name }}</div>
              <div class="begin">
                <span class="t">起始时间</span>{{ stem.times.begin }}
              </div>
              <div class="end">
                <span class="t">结束时间</span>{{ stem.times.end }}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="xy" v-if="current !== 2">
        <img src="./assets/r.png" class="rpng" alt="" /> 我已阅读并同意
        <span class="" @click="openDoalog(0)">《个人信息授权书》</span>
        <span class="" @click="openDoalog(1)">《用户协议》</span>
        <span class="" @click="openDoalog(2)">《隐私协议》</span>
      </div>
    </div>

    <!-- 底部浮动栏 -->
    <div class="flotN" v-if="current !== 2">
      <div class="fTip">
        <div class="fleft">
          <div class="fs">发送至邮箱</div>
          <div class="fv">{{ email }}</div>
        </div>
        <div>
          <div class="fright">复制并前往</div>
        </div>
      </div>
      <div class="fbut">
        <el-button type="primary" round>{{ useButLabel }}</el-button>
      </div>
    </div>
    <div class="flot" v-if="current !== 2">
      <div class="fTip">
        <div class="fleft">
          <div class="fs">发送至邮箱</div>
          <div class="fv">{{ email }}</div>
        </div>
        <div>
          <div class="fright" @click="copyEmail">复制并前往</div>
        </div>
      </div>
      <div class="fbut">
        <el-button type="primary" round @click="chaangeLabel">{{
          useButLabel
        }}</el-button>
      </div>
    </div>

    <!-- <div class="flot" v-if="current === 2">
      <div class="fTip">
        <div class="fleft">
          <div class="fs">发送至邮箱</div>
          <div class="fv">{{ email }}</div>
        </div>
        <div>
          <div class="fright" @click="copyEmail">复制并前往</div>
        </div>
      </div>
      <div class="fbut">
        <el-button type="primary" round @click="chaangeLabel">{{
          useButLabel
        }}</el-button>
      </div>
    </div> -->

    <!-- 银行账单底部浮动栏 -->
    <div class="bank-flot" v-if="current === 2">
      <div class="bank-flot-tip">
        <div class="bank-flot-left">
          <!-- <img src="./assets/r.png" alt="" /> -->
          <div>
            <div class="fs">发送至邮箱：</div>
            <div class="fv">{{ email }}</div>
          </div>
        </div>
        <div class="bank-flot-copy" @click="copyEmail">复制并前往</div>
      </div>
      <!-- <div class="bank-upload-tip" @click="handleUpload">
        <img src="./assets/r.png" alt="" />
        点击此处上传账单文件
      </div> -->
      <div class="fbut">
        <el-button type="primary" round @click="handleBankDone"
          >我已完成</el-button
        >
      </div>
    </div>

    <!-- 协议弹窗 -->
    <el-dialog
      :visible.sync="centerDialogVisible"
      width="90%"
      style="border-radius: 10px; height: 100vh; overflow: auto"
      center
      custom-class="doLog"
      :show-close="false"
    >
      <div class="dMian" v-html="usePop"></div>
      <div class="close">
        <el-button @click="centerDialogVisible = false" type="primary"
          >确定</el-button
        >
      </div>
    </el-dialog>

    <!-- 银行选择抽屉 -->
    <el-drawer
      :visible.sync="bankDrawerVisible"
      direction="rtl"
      size="50%"
      :with-header="false"
      custom-class="bank-drawer"
    >
      <div class="bank-drawer-header">
        <div class="bank-drawer-title">银行列表</div>
        <i class="el-icon-close" @click="bankDrawerVisible = false"></i>
      </div>
      <div class="bank-search">
        <i class="el-icon-search"></i>
        <input
          type="text"
          v-model="bankSearchKey"
          placeholder="输入搜索关键词"
        />
      </div>
      <div class="bank-drawer-body">
        <div
          class="bank-category"
          v-for="(cat, cIndex) in filteredBankList"
          :key="cIndex"
        >
          <div class="bank-category-title">{{ cat.category }}</div>
          <div class="bank-items">
            <div
              class="bank-item"
              v-for="(bank, bIndex) in cat.banks"
              :key="bIndex"
              :class="{
                active: selectedBank && selectedBank.name === bank.name,
              }"
              @click="selectBank(bank)"
            >
              <!-- <div class="bank-icon"> -->
              <img class="bank-icon" v-if="bank.icon" :src="bank.icon" alt="" />
              <!-- {{ bank.name.charAt(0) }}
              </div> -->
              <span class="bank-name">{{ bank.name }}</span>
            </div>
          </div>
        </div>
      </div>
    </el-drawer>
  </div>
</template>
<script>
// 脚本部分完全不变
import zfbPng from "./assets/zfb/zfb.png";
import zfbnPng from "./assets/zfb/zfbn.png";
import wxPng from "./assets/wx/wx.png";
import wxnPng from "./assets/wx/wxn.png";
import ylPng from "./assets/v2/yl.png";
import ylhPng from "./assets/v2/ylh.png";
import tdPng from "./assets/v2/td.png";
import ggtPng from "./assets/v2/gt.png";

import zfb1 from "./assets/zfb/zfb_1.png";
import zfb2 from "./assets/zfb/zfb_2.png";
import zfb3 from "./assets/zfb/zfb_3.png";
import zfb4 from "./assets/zfb/zfb_4.png";
import zfb5 from "./assets/zfb/zfb_5.png";
import zfb6 from "./assets/zfb/zfb_6.png";

import wx1 from "./assets/wx/w1_1.png";
import wx2 from "./assets/wx/w1_2.png";
import wx3 from "./assets/wx/w1_3.png";
import wx4 from "./assets/wx/w1_4.png";
import wx5 from "./assets/wx/w1_5.png";
import wx6 from "./assets/wx/w1_6.png";
import wx7 from "./assets/wx/w1_7.png";
import wx8 from "./assets/wx/w1_8.png";

// 银行 logo 与 bankList / 各银行指引统一来自 yhCenter
import { grxxsqs, yhxy, ysxy } from "./data";
import { bankList, yhCenter } from "./yhCenter/yhCenter";

export default {
  data() {
    return {
      email: "aeq9q9@eeiai.cn",
      centerDialogVisible: false,
      tabs: [
        { label: "支付宝账单", icon: zfbPng, iconN: zfbnPng },
        { label: "微信账单", icon: wxPng, iconN: wxnPng },
        { label: "银行账单", icon: ylPng, iconN: ylhPng },
      ],
      current: 2,
      grxxsqs,
      yhxy,
      ysxy,
      use: 0,
      zfb: [
        {
          name: "找账单",
          msgList: [
            { msg: "进入支付宝->我->账单->右上角···->点击“开具流水交易证明”" },
            { imgs: [zfb1, zfb2, zfb3] },
          ],
        },
        {
          name: "下载账单",
          msgList: [
            {
              msgs: [
                { r1: "用作材料证明" },
                { r2: "（一定此项）" },
                { t: "->点击全部交易->自定义时间范围选择近12个月->发送至邮箱" },
                { b1: "aeq9q9@eeiai.cn" },
              ],
            },
            {
              times: {
                name: "时间选择示例（范围12个月！）:",
                begin: "2025年11月16日",
                end: "2024年11月17日",
              },
            },
            { imgs: [zfb4, zfb5, zfb6] },
          ],
        },
      ],
      wx: [
        {
          name: "找账单",
          msgList: [
            { msg: "进入微信->我->服务->钱包->客服中心" },
            { imgs: [wx1, wx2, wx3] },
          ],
        },
        {
          name: "下载账单",
          msgList: [
            {
              msgs: [
                { t: "下载账单->" },
                { r1: "用作材料证明" },
                { r2: "（一定此项）" },
              ],
            },
            { imgs: [wx4, wx5] },
            {
              blueBox: true,
              msgs: [
                { t: "选择接收方式为" },
                { r1: "邮箱" },
                { t: "->点击自定义时间选择12个月->发送至邮箱" },
                { b1: "aeq9q9@eeiai.cn" },
              ],
            },
            {
              times: {
                name: "时间选择示例（范围12个月！）:",
                begin: "2025年11月16日",
                end: "2024年11月17日",
              },
            },
            { imgs: [wx7, { t: "或" }, { m: wx8, sw: "160px" }] },
          ],
        },
      ],
      ylPng,
      ylhPng,
      tdPng,
      ggtPng,
      // 银行选择相关
      bankDrawerVisible: false,
      bankSearchKey: "",
      selectedBank: null,
      bankList,
      // 各银行指南数据（与 yhCenter.js 中 yhCenter 对应）
      bankGuideData: yhCenter,
    };
  },
  computed: {
    themeClass() {
      if (this.current === 0) return "blue-theme";
      if (this.current === 1) return "green-theme";
      return "bank-theme";
    },
    useContent() {
      return this.current == 0 ? this.zfb : this.wx;
    },
    useButLabel() {
      return this.current == 0 ? "我已完成，去微信账单" : "我已完成";
    },
    usePop() {
      if (this.use == 0) {
        let today = new Date();
        this.grxxsqs = this.grxxsqs.replace(
          /AuthorizationDate/,
          today.getFullYear() +
            "-" +
            (today.getMonth() + 1) +
            "-" +
            today.getDate(),
        );
      }
      return this.use == 0
        ? this.grxxsqs
        : this.use == 1
        ? this.yhxy
        : this.ysxy;
    },
    srcList() {
      let src = [];
      for (let k in this.useContent) {
        if (this.useContent[k].msgList) {
          for (let s in this.useContent[k].msgList) {
            if (this.useContent[k].msgList[s].imgs) {
              for (let m in this.useContent[k].msgList[s].imgs) {
                if (!this.useContent[k].msgList[s].imgs[m].t) {
                  src.push(
                    this.useContent[k].msgList[s].imgs[m].m ||
                      this.useContent[k].msgList[s].imgs[m],
                  );
                }
              }
            }
          }
        }
      }
      return src;
    },
    filteredBankList() {
      const key = this.bankSearchKey.trim();
      if (!key) return this.bankList;
      return this.bankList
        .map((cat) => ({
          ...cat,
          banks: cat.banks.filter((b) => b.name.includes(key)),
        }))
        .filter((cat) => cat.banks.length > 0);
    },
    currentBankGuide() {
      if (!this.selectedBank) return [];
      console.log("this.selectedBank.key", this.selectedBank.key);
      return (
        this.bankGuideData[this.selectedBank.key] || [
          {
            name: "操作指引",
            msgList: [
              {
                msg:
                  "请登录" +
                  this.selectedBank.name +
                  "APP，搜索“打印交易流水”或“年度账单”，选择近一年账单并发送至邮箱。",
              },
            ],
          },
        ]
      );
    },
    bankSrcList() {
      let src = [];
      const list = this.currentBankGuide;
      for (let k in list) {
        if (list[k].msgList) {
          for (let s in list[k].msgList) {
            if (list[k].msgList[s].imgs) {
              for (let m in list[k].msgList[s].imgs) {
                if (!list[k].msgList[s].imgs[m].t) {
                  src.push(
                    list[k].msgList[s].imgs[m].m || list[k].msgList[s].imgs[m],
                  );
                }
              }
            }
          }
        }
      }
      return src;
    },
  },
  methods: {
    change(i) {
      this.current = i;
    },
    openDoalog(i) {
      this.use = i;
      this.centerDialogVisible = true;
    },
    chaangeLabel() {
      this.current = this.current == 0 ? 1 : 0;
    },
    copyEmail() {
      const email = this.email;
      if (!email) {
        this.$message.error("复制内容不能为空");
        return;
      }

      try {
        if (navigator.clipboard && window.isSecureContext) {
          navigator.clipboard.writeText(email).then(
            () => {
              this.$message.success("邮箱复制成功！");
            },
            (err) => {
              console.error("Clipboard API 复制失败：", err);
              this.fallbackCopy(email);
            },
          );
        } else {
          this.fallbackCopy(email);
        }
      } catch (error) {
        console.error("复制异常：", error);
        this.$message.error("复制失败，请手动复制邮箱");
      }
    },

    fallbackCopy(text) {
      const textarea = document.createElement("textarea");
      textarea.value = text;
      textarea.style.position = "fixed";
      textarea.style.left = "-9999px";
      textarea.style.top = "-9999px";
      textarea.style.opacity = "0";
      document.body.appendChild(textarea);

      try {
        textarea.select();
        textarea.setSelectionRange(0, text.length);
        const success = document.execCommand("copy");
        if (success) {
          this.$message.success("邮箱复制成功！");
        } else {
          throw new Error("execCommand 复制失败");
        }
      } catch (err) {
        console.error("兼容方案复制失败：", err);
        this.$message.error("复制失败，请手动复制邮箱");
      } finally {
        document.body.removeChild(textarea);
      }
    },

    // 银行账单相关方法
    openBankDrawer() {
      this.bankDrawerVisible = true;
    },
    selectBank(bank) {
      this.selectedBank = bank;
      this.bankDrawerVisible = false;
    },
    handleUpload() {
      this.$message.info("请上传您的账单文件");
    },
    handleBankDone() {
      this.$message.success("操作完成");
    },
  },
};
</script>
<style scoped>
/* 基础布局样式完全不变，仅修复背景色显示问题 */
.fccC {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}
* {
  box-sizing: border-box;
}
.fcb {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.fcc {
  display: flex;
  align-items: center;
  justify-content: center;
}
.f1 {
  flex: 1;
}
.tabs {
  padding-bottom: 20px;
}
.tab {
  color: #fff;
  font-weight: 700;
  background: linear-gradient(
    180deg,
    hsla(0, 0%, 100%, 0.4),
    hsla(0, 0%, 100%, 0.35)
  );
  padding: 12px;
  margin-right: 12px;
  border-radius: 12px;
  transition: all 0.5s;
  position: relative;
}
.tab::after {
  content: "";
  display: inline-block;
  position: absolute;
  left: 50%;
  bottom: 0;
  border: 0px solid #fff;
  border-top-color: transparent;
  border-left-color: transparent;
  transform: translate(-50%, 50%) rotate(45deg);
  transition: all 0.5s;
}
.tab:first-child {
  margin-left: 12px;
}
.icon {
  width: 24px;
  height: 24px;
}
.choose {
  background-color: #fff;
}
.choose::after {
  border: 8px solid #fff;
  border-top-color: transparent;
  border-left-color: transparent;
}
.main {
  padding: 12px 12px;
  background-color: #fff;
  margin: 0 5%;
  border-radius: 10px;
}
.tip {
  font-size: 14px;
  padding: 5px 10px;
  border-radius: 10px;
}
.tip img {
  width: 18px;
  height: 18px;
}
.name {
  font-size: 14px;
  font-weight: 700;
}
.msg {
  font-size: 14px;
  color: #383838;
  font-weight: 500;
}
.el-image {
  /* width: 80px;
  height: 80px; */
}
.imgOnce {
  flex: 0.333;
}
.imgs {
  display: flex;
  align-items: center;
  /* flex-wrap: wrap; */
  justify-content: left;
}

.t {
  font-size: 14px;
  color: #383838;
  font-weight: 500;
}
.r1 {
  font-size: 14px;
  color: red;
  font-weight: 500;
}
.r2 {
  font-size: 10px;
  color: red;
  font-weight: 500;
}
.b1 {
  font-size: 14px;
  font-weight: 500;
}
.times {
  border-radius: 10px;
  margin-bottom: 20px;
  display: flex;
  flex-direction: column;
  padding: 8px;
}
.times .title {
  font-size: 14px;
  color: #383838;
  padding-bottom: 8px;
}
.times .begin,
.times .end {
  height: 30px;
  font-weight: 700;
}
.times .begin .t,
.times .end .t {
  color: #383838;
  height: 30px;
  font-weight: 700;
}
.times .begin .t::before,
.times .end .t::before {
  content: "";
  display: inline-block;
  width: 5px;
  height: 5px;
  border-radius: 50%;
  margin-right: 8px;
  margin-left: 4px;
}
.mainC > div,
.name {
  margin-top: 8px;
}
.rpng {
  width: 16px;
  height: 16px;
}
.xy {
  font-size: 12px;
  font-weight: 400;
  margin-top: 16px;
}
.xy span {
  cursor: pointer;
}
.dMian {
  overflow: auto;
}
:deep(.doLog) {
  margin-top: 20px !important;
  margin-bottom: 20px !important;
  height: calc(100vh - 40px);
  border-radius: 10px;
  overflow-y: auto;
}
:deep(.doLog) .el-dialog__header {
  display: none;
}
:deep(.dMian) img {
  width: 100%;
}
:deep(.dMian) button {
  display: none;
}
.close {
  position: fixed;
  bottom: 36px;
  right: 36px;
}
.blueBox {
  font-size: 14px;
  padding: 5px 10px;
  border-radius: 10px;
}
.flot {
  background-color: #fff;
  position: fixed;
  left: 0;
  bottom: 0;
  width: 100%;
  padding: 8px;
  border-radius: 8px 8px 0 0;
}
.fTip {
  display: flex;
  align-items: center;
  border-radius: 10px;
  margin: 0 auto 0;
  padding: 0 10px;
  position: relative;
  color: #fff;
}
.fleft {
  flex: 1;
  padding: 8px;
}
.fbut {
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 10px 0;
}
.fv {
  font-size: 19px;
  font-weight: 600;
}
.fright {
  font-size: 16px;
  background: linear-gradient(180deg, #f5f7fa, #f5f7fa);
  padding: 3px 12px;
  border-radius: 12px;
}
.flotN {
  position: relative;
  padding-top: 18px;
  opacity: 0;
  user-select: none;
  pointer-events: none;
}
.once {
  position: relative;
  padding-left: 8px;
}
.once::before {
  content: "";
  display: inline-block;
  width: 1px;
  height: calc(100% - 16px);
  position: absolute;
  left: 0;
  top: 16px;
}
.name {
  position: relative;
  padding-left: 8px;
}
.el-icon-success {
  position: absolute;
  left: 0;
  top: 50%;
  transform: translate(-100%, -50%);
}

/* 修复背景色：直接给主题类设置背景，不嵌套 .bodyMain，提高优先级 */
.blue-theme {
  background: linear-gradient(180deg, #6aadfc, #d2e8fd) !important;
  min-height: 100vh;
  padding: 12px 0;
}
.green-theme {
  background: linear-gradient(180deg, #4caf50, #e8f5e9) !important;
  min-height: 100vh;
  padding: 12px 0;
}

/* 蓝色主题（current=0 支付宝账单） */
.blue-theme .choose {
  color: #000;
}
.blue-theme .tip {
  background: #edf5ff;
}
.blue-theme .name {
  color: #1c86ff;
}
.blue-theme .b1 {
  color: #268afc;
}
.blue-theme .times {
  background: #edf5ff;
}
.blue-theme .times .begin,
.blue-theme .times .end {
  color: #2e84e4;
}
.blue-theme .times .begin .t::before,
.blue-theme .times .end .t::before {
  background-color: #2e84e4;
}
.blue-theme .xy span {
  color: #268afc;
}
.blue-theme .blueBox {
  background: #edf5ff;
}
.blue-theme .fTip {
  background: linear-gradient(90deg, #ffa463, #ffc261);
}
.blue-theme .fright {
  color: #268afc;
}
.blue-theme .once::before {
  background-color: #1c86ff;
}
.blue-theme .el-icon-success {
  color: #1c86ff;
}
.blue-theme :deep(.el-button--primary) {
  background-color: #1c86ff !important;
  border-color: #1c86ff !important;
}
.blue-theme :deep(.el-button--primary:hover) {
  background-color: #268afc !important;
  border-color: #268afc !important;
}

/* 绿色主题（current=1 微信账单） */
.green-theme .choose {
  color: #388e3c;
}
.green-theme .tip {
  background: #e8f5e9;
}
.green-theme .name {
  color: #4caf50;
}
.green-theme .b1 {
  color: #383838;
}
.green-theme .times {
  background: #e8f5e9;
}
.green-theme .times .begin,
.green-theme .times .end {
  color: #388e3c;
}
.green-theme .times .begin .t::before,
.green-theme .times .end .t::before {
  background-color: #4caf50;
}
.green-theme .xy span {
  color: #388e3c;
}
.green-theme .blueBox {
  background: #e8f5e9;
}
.green-theme .fTip {
  background: linear-gradient(90deg, #81c784, #4caf50);
}
.green-theme .fright {
  color: #388e3c;
}
.green-theme .once::before {
  background-color: #4caf50;
}
.green-theme .el-icon-success {
  color: #4caf50;
}
.green-theme :deep(.el-button--primary) {
  background-color: #4caf50 !important;
  border-color: #4caf50 !important;
}
.green-theme :deep(.el-button--primary:hover) {
  background-color: #388e3c !important;
  border-color: #388e3c !important;
}

/* ===== 银行账单主题（current=2） ===== */
.bank-theme {
  background: linear-gradient(180deg, #6aadfc, #d2e8fd) !important;
  min-height: 100vh;
  padding: 12px 0;
}
.bank-theme .main {
  padding: 0 0 0px 0;
  overflow: hidden;
}
.bank-theme .choose {
  color: #000;
}

/* 银行头部 */
.bank-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px;
}
.bank-header-title {
  font-size: 18px;
  font-weight: 700;
  color: #1c86ff;
}
.bank-header-picker {
  display: flex;
  align-items: center;
  color: #1c86ff;
  font-size: 14px;
  padding-right: 14px;
  position: relative;
}
.bank-header-picker::after {
  content: "";
  position: absolute;
  right: 0;
  top: 50%;
  width: 8px;
  height: 8px;
  border-top: 2px solid #1c86ff;
  border-right: 2px solid #1c86ff;
  transform: translateY(-50%) rotate(45deg);
}

/* 银行空状态 */
.bank-empty {
  position: relative;
  margin: 0 12px 12px;
  border-radius: 10px;
  overflow: hidden;
  background: #f6fbff;
}
.bank-empty-bg {
  width: 100%;
  display: block;
}
.bank-empty-tip {
  position: absolute;
  top: 70px;
  left: 16px;
  width: calc(100% - 32px);
}
.bank-empty-tip1 {
  font-size: 16px;
  font-weight: 500;
  margin-bottom: 6px;
}
.bank-empty-tip2 {
  font-size: 16px;
  font-weight: 500;
  margin-bottom: 6px;
}
.bank-empty-tip3 {
  width: 100%;
  display: flex;
  align-items: center;
  font-size: 12px;
  color: #1c86ff;
  background: rgba(255, 255, 255, 0.8);
  padding: 4px 8px;
  border-radius: 12px;
}
.bank-empty-tip3 img {
  width: 14px;
  height: 14px;
  margin-right: 4px;
}
.up-bill {
  position: absolute;
  left: 50%;
  bottom: 40px;
  transform: translateX(-50%);
  width: 70%;
  height: 44px;
  line-height: 44px;
  text-align: center;
  background: #fff;
  color: #1c86ff;
  border-radius: 22px;
  font-size: 16px;
  font-weight: 500;
  box-shadow: 0 4px 12px rgba(28, 134, 255, 0.15);
}

/* 银行指南内容 */
.bank-guide {
  padding: 0 12px 12px;
}
.bank-guide-tip {
  font-size: 14px;
  padding: 5px 10px;
  border-radius: 10px;
  /* background: #edf5ff; */
  margin-bottom: 10px;
}
.bank-guide-tip img {
  width: 18px;
  height: 18px;
  margin-right: 4px;
}
.bank-guide .content {
  background: #fff;
  border-radius: 10px;
  padding: 12px;
}
.bank-guide .name {
  color: #1c86ff;
}
.bank-guide .once::before {
  background-color: #1c86ff;
}
.bank-guide .el-icon-success {
  color: #1c86ff;
}

/* 银行底部浮动栏 */
.bank-flot {
  background-color: #fff;
  position: fixed;
  left: 0;
  bottom: 0;
  width: 100%;
  padding: 8px;
  border-radius: 8px 8px 0 0;
}
.bank-flot-tip {
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-radius: 10px;
  padding: 8px 10px;
  padding-left: 18px;
  background: linear-gradient(90deg, #ffa463, #ffc261);
  color: #fff;
  margin-bottom: 8px;
}
.bank-flot-left {
  display: flex;
  align-items: center;
}
.bank-flot-left img {
  width: 20px;
  height: 20px;
  margin-right: 8px;
}
.bank-flot-copy {
  font-size: 16px;
  /* background: linear-gradient(180deg, #f5f7fa, #f5f7fa); */
  background: #fff;
  color: #ffa463;
  padding: 3px 12px;
  border-radius: 12px;
}
.bank-upload-tip {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  color: #1c86ff;
  background: #edf5ff;
  border-radius: 10px;
  padding: 8px;
  margin-bottom: 8px;
}
.bank-upload-tip img {
  width: 16px;
  height: 16px;
  margin-right: 4px;
}
.bank-theme :deep(.el-button--primary) {
  background-color: #1c86ff !important;
  border-color: #1c86ff !important;
}
.bank-theme :deep(.el-button--primary:hover) {
  background-color: #268afc !important;
  border-color: #268afc !important;
}

/* 银行选择抽屉 */
:deep(.bank-drawer) {
  border-radius: 0;
  overflow: hidden;
}
.bank-drawer-header {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
  position: relative;
}
.bank-drawer-title {
  font-size: 18px;
  font-weight: 700;
  color: #303133;
}
.bank-drawer-header .el-icon-close {
  position: absolute;
  right: 16px;
  top: 50%;
  transform: translateY(-50%);
  font-size: 20px;
  color: #909399;
}
.bank-search {
  display: flex;
  align-items: center;
  background: #f5f7fa;
  border-radius: 20px;
  padding: 8px 12px;
  margin: 0 16px 12px;
}
.bank-search i {
  color: #909399;
  margin-right: 8px;
}
.bank-search input {
  flex: 1;
  border: none;
  background: transparent;
  outline: none;
  font-size: 14px;
  color: #303133;
}
.bank-drawer-body {
  padding: 0 16px 16px;
  height: calc(100% - 110px);
  overflow-y: auto;
}
.bank-category {
  margin-bottom: 16px;
}
.bank-category-title {
  font-size: 16px;
  font-weight: 700;
  color: #1c86ff;
  padding-left: 8px;
  border-left: 4px solid #1c86ff;
  margin-bottom: 10px;
}
.bank-items {
  display: flex;
  /* flex-wrap: wrap; */
  flex-direction: column;
}
.bank-item {
  width: 100%;
  display: flex;
  /* flex-direction: column; */
  align-items: center;
  padding: 10px 0;
  border-radius: 8px;
  padding-left: 30px;
}
.bank-item.active {
  background: #edf5ff;
}
.bank-icon 
/* img  */ {
  width: 14px;
  height: 14px;
  margin-right: 4px;
}
/* .bank-icon {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-size: 14px;
  font-weight: 700;
  margin-bottom: 6px;
} */
.bank-name {
  font-size: 12px;
  color: #303133;
}
</style>
